export const SURVEY_QUERY_KEY = 'survey';
export const SURVEY_RESULTS_QUERY_KEY = 'surveyResults';
export const SURVEYS_QUERY_KEY = 'surveys';
export const SURVEY_TEMPLATES_QUERY_KEY = 'surveyTemplates';
